import React, { useState, useEffect } from 'react';
import { Banknote, ShieldCheck, Zap, Settings2, TrendingUp, Users, Clock, CheckCircle, Star, Heart, Target, Award } from 'lucide-react';
import { benefits as mockBenefits } from '../../data/mock';
import { cmsService } from '../../services/cmsService';

const iconMap = {
  Banknote,
  ShieldCheck,
  Zap,
  Settings2,
  TrendingUp,
  Users,
  Clock,
  CheckCircle,
  Star,
  Heart,
  Target,
  Award,
};

const Benefits = () => {
  const [benefits, setBenefits] = useState(mockBenefits);

  useEffect(() => {
    cmsService.getBenefits().then(data => {
      if (data && data.length > 0) setBenefits(data);
    }).catch(() => {});
  }, []);

  return (
    <section id="beneficios" className="py-24 bg-white relative overflow-hidden" data-testid="benefits-section">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-[#0092ca]/5 to-transparent" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-2 bg-[#0092ca]/10 text-[#0092ca] text-sm font-semibold rounded-full mb-4">
            Ventajas
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            ¿Por qué elegir{' '}
            <span className="text-[#0092ca]">FACTORYZA</span>?
          </h2>
          <p className="text-lg text-gray-600">
            Transformamos tus cuentas por cobrar en capital de trabajo inmediato, 
            con las mejores condiciones del mercado panameño.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => {
            const IconComponent = iconMap[benefit.icon];
            return (
              <div
                key={benefit.id}
                data-testid={`benefit-card-${index}`}
                className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-[#0092ca]/30 hover:-translate-y-2"
                style={{ animationDelay: `${index * 100}ms` }}>

                {/* Icon */}
                <div className="w-14 h-14 bg-gradient-to-br from-[#0092ca]/10 to-[#0092ca]/5 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  {IconComponent &&
                  <IconComponent className="w-7 h-7 text-[#0092ca]" />
                  }
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#0092ca] transition-colors">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {benefit.description}
                </p>

                {/* Hover decoration */}
                <div className="absolute top-0 right-0 w-24 h-24 bg-[#0092ca]/5 rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <p className="text-gray-500 mb-4">Impulsemos tu negocio juntos.</p>
          <a
            href="#contacto"
            className="inline-flex items-center gap-2 text-[#0092ca] font-semibold hover:gap-4 transition-all duration-300">
            Solicita una evaluación gratuita
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
